var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'cmp-catalog-statement-sidewindow-send_log',"addButton":false,"addLink":false,"addLinkLabel":((_vm.$t('add_new')) + " " + (_vm.$t('genre'))),"rightMenu":[
            {
                text: 'Empty Log',
                value: 'Empty Log',
            } ]},on:{"menuClick":_vm.onRightMenuClick}},[(_vm.log.length>0)?[_c('div',{class:{ 'bbb':_vm.log.length>0?true:false}},_vm._l((_vm.log),function(item,index){return _c('p',{key:index},[_vm._v(_vm._s(item))])}),0)]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }